module.exports = __webpack_public_path__ + "img/pwichka.3fde321c.svg";